import React from "react";
import { node } from "prop-types";
import { sxClassName, sxProps, sxPropTypes } from "@insightfulscience/atomic-react/props/sx";
import { classes } from "@insightfulscience/atomic-react/utils/classes";

const CardPriceOne = ({ price, period, children, priceSX = { ...sxProps } }) => {
	return (
		<div className="card-price__one">
			<div className={classes("card-price__one-price", ...sxClassName(priceSX))}>{price}</div>
			<div className="card-price__one-period">{period}</div>
			{children}
		</div>
	);
};

CardPriceOne.propTypes = {
	price: node.isRequired,
	period: node.isRequired,
	priceSX: sxPropTypes,
	children: node,
};

export default CardPriceOne;
